import {onMounted, onUnmounted} from "vue";
import axios from "axios";

export function useRealTimeDataService(callback, page_id, {
    interval = 10000,
    dataType = 0,
    checkFR /*是否检测首次请求*/,
    nodeTypes = -1,
    location = '',
    alert = false
}){
    let timerId = null;
    let checkFirstRequest = -1, ex = false;
    let _interrupt = false; //是否中断请求

    function interrupted(interrupt = true) {//设置是否中断请求
        if (interrupt && (_interrupt != interrupt)){
            realTimeData(page_id); //重新设置false，不打断，立即更新数据。
        }
        _interrupt = interrupt;
    }

    function realTimeData(page_id){
        if (_interrupt) return;
        ex = false;
        axios.get(`/realtime/data?page_id=${page_id ?? ''}&data_type=${dataType}&nodeCnt=${checkFirstRequest}&nodeTypes=${nodeTypes}&location=${location}&alert=${alert}`)
            .then(function (response) {
               if (response.data.code == 0){
                    callback(response.data.data)
                }
            })
            .catch(function () {
                // console.log("网络请求失败，请稍后重试")
                ex = true;
            })
            .finally(function () {
                // console.log("finally")
                if ((checkFirstRequest == -1) && checkFR && !ex){
                    checkFirstRequest = 1;
                }
            });
    }

    onMounted(() => {
        timerId = setInterval(() => {
            realTimeData(page_id);
        }, interval);
        realTimeData(page_id);
    })
    onUnmounted(() => {
        clearInterval(timerId);
    })

    return {interrupted}
}